import type React from "react";

import styles from "./styles.module.scss";

interface MarkdownContentProps {
  children: React.ReactNode;
  className?: string;
}

const joinClassNames = (...classes: Array<string | undefined | false>): string =>
  classes.filter(Boolean).join(" ");

const MarkdownContent: React.FC<MarkdownContentProps> = ({ children, className }) => (
  <div className={joinClassNames(styles["wrapper"], className)}>{children}</div>
);

/** MarkdownEditorPreview の previewClassName に渡すためのクラス名 */
const markdownContentClassName = styles["wrapper"] as string;

export { MarkdownContent, markdownContentClassName };
